/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import VerticalSplit from "../../../Basis/Components/VerticalSplit";
import AppRouterDefinition from "./../../../AppRouterDefinition";

const MahlzeitenView = React.lazy(() => import(/* webpackChunkName: "Mahlzeiten" */ "../Views/MahlzeitenView"));
const MahlzeitenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Mahlzeiten" */ "../Components/MahlzeitenBreadcrumb"));
const MahlzeitenNavigationView = React.lazy(() => import(/* webpackChunkName: "Mahlzeiten" */ "../Views/MahlzeitenNavigtionView"));
const MahlzeitDetailsView = React.lazy(() => import(/* webpackChunkName: "Mahlzeiten" */ "../Views/MahlzeitDetailsView"));
const MahlzeitView = React.lazy(() => import(/* webpackChunkName: "Mahlzeiten" */ "../Views/MahlzeitView"));
const MahlzeitBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Mahlzeiten" */ "../Components/MahlzeitBreadcrumb"));
const VerpflegungsartenView = React.lazy(() => import(/* webpackChunkName: "Mahlzeiten" */ "../Views/VerpflegungsartenView"));
const VerpflegungsartenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Mahlzeiten" */ "../Components/VerpflegungsartenBreadcrumb"));
const VerpflegungsartView = React.lazy(() => import(/* webpackChunkName: "Mahlzeiten" */ "../Views/VerpfelgungsartView"));
const VerpflegungsartBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Mahlzeiten" */ "../Components/VerpflegungsartBreadcrumb"));
const VerpflegungsartenNavigationView = React.lazy(() => import(/* webpackChunkName: "Mahlzeiten" */ "../Views/VerpflegungsartenNavigtionView"));
const VerpflegungsartDetailsView = React.lazy(() => import(/* webpackChunkName: "Mahlzeiten" */ "../Views/VerpflegungsartDetailsView"));
const VerpflegungsartMahlzeitenView = React.lazy(() => import(/* webpackChunkName: "Mahlzeiten" */ "../Views/VerpflegungsartMahlzeitenView"));
const VerpflegungsartMahlzeitenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Mahlzeiten" */ "../Components/VerpflegungsartMahlzeitenBreadcrumb"));
const PreiseView = React.lazy(() => import(/* webpackChunkName: "Mahlzeiten" */ "../Views/PreiseView"));
const PreiseBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Mahlzeiten" */ "../Components/PreiseBreadcrumb"));
const PreisView = React.lazy(() => import(/* webpackChunkName: "Mahlzeiten" */ "../Views/PreisView"));
const PreiseNavigationView = React.lazy(() => import(/* webpackChunkName: "Mahlzeiten" */ "../Views/PreiseNavigtionView"));
const PreisBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Mahlzeiten" */ "../Components/PreisBreadcrumb"));
const PreisDetailsView = React.lazy(() => import(/* webpackChunkName: "Mahlzeiten" */ "../Views/PreisDetailsView"));
const PreispositionenView = React.lazy(() => import(/* webpackChunkName: "Mahlzeiten" */ "../Views/PreispositionenView"));
const PreispositionenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Mahlzeiten" */ "../Components/PreispositionenBreadcrumb"));
const PreispositionView = React.lazy(() => import(/* webpackChunkName: "Mahlzeiten" */ "../Views/PreispositionView"));
const PreispositionBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Mahlzeiten" */ "../Components/PreispositionBreadcrumb"));
const PreispositionDetailsView = React.lazy(() => import(/* webpackChunkName: "Mahlzeiten" */ "../Views/PreispositionDetailsView"));
const PreispositionenNavigationView = React.lazy(() => import(/* webpackChunkName: "Mahlzeiten" */ "../Views/PreispositionenNavigationView"));

const MAHLZEITEN_PATH = "/mahlzeiten";
const MAHLZEIT_PATH = "/mahlzeit/:mahlzeitId";
const VERPFLEGUNGSARTEN_PATH = "/verpflegungsarten";
const VERPFLEGUNGSART_PATH = "/verpflegungsart/:verpflegungsartId";
const MAHLZEIT_PREISE_PATH = `${MAHLZEIT_PATH}/preise`;
const MAHLZEIT_PREIS_PATH = `${MAHLZEIT_PATH}/preis/:preisId`;
const MAHLZEIT_PREISPOSITIONEN_PATH = `${MAHLZEIT_PREIS_PATH}/positionen`;
const MAHLZEIT_PREISPOSITION_PATH = `${MAHLZEIT_PREIS_PATH}/position/:preispositionId`;

export const mahlzeitenRouterDefintions: Array<AppRouterDefinition> = [
    {
        path: MAHLZEITEN_PATH,
        render: () => <MahlzeitenView />,
        createBreadcrumbs: () => [<MahlzeitenBreadcrumb />],
    },
    {
        path: MAHLZEIT_PATH,
        render: props => <VerticalSplit
            left={() => <MahlzeitenNavigationView {...props}/>}
            right={() => <MahlzeitView {...props}/>}
        />,
        createBreadcrumbs: props => [
            <MahlzeitenBreadcrumb />,
            <MahlzeitBreadcrumb {...props}/>
        ]
    },
    {
        path: MAHLZEIT_PATH,
        parentPath: MAHLZEIT_PATH,
        exact: true,
        render: props => <MahlzeitDetailsView {...props} />,
        createBreadcrumbs: props => [
            <MahlzeitenBreadcrumb />,
            <MahlzeitBreadcrumb {...props}/>
        ]
    },
    {
        path: MAHLZEIT_PREISE_PATH,
        parentPath: MAHLZEIT_PATH,
        exact: true,
        render: props => <PreiseView {...props} />,
        createBreadcrumbs: props => [
            <MahlzeitenBreadcrumb />,
            <MahlzeitBreadcrumb {...props}/>,
            <PreiseBreadcrumb {...props}/>,
        ]
    },
    {
        path: VERPFLEGUNGSARTEN_PATH,
        render: () => <VerpflegungsartenView />,
        createBreadcrumbs: () => [<VerpflegungsartenBreadcrumb />],
    },
    {
        path: VERPFLEGUNGSART_PATH,
        render: props => <VerticalSplit
            left={() => <VerpflegungsartenNavigationView {...props}/>}
            right={() => <VerpflegungsartView {...props}/>}
        />,
        createBreadcrumbs: props => [
            <VerpflegungsartenBreadcrumb />,
            <VerpflegungsartBreadcrumb {...props}/>
        ]
    },
    {
        path: VERPFLEGUNGSART_PATH,
        parentPath: VERPFLEGUNGSART_PATH,
        exact: true,
        render: props => <VerpflegungsartDetailsView {...props} />,
        createBreadcrumbs: props => [
            <VerpflegungsartenBreadcrumb />,
            <VerpflegungsartBreadcrumb {...props}/>
        ]
    },
    {
        path: `${VERPFLEGUNGSART_PATH}/mahlzeiten`,
        parentPath: VERPFLEGUNGSART_PATH,
        exact: true,
        render: props => <VerpflegungsartMahlzeitenView {...props} />,
        createBreadcrumbs: props => [
            <VerpflegungsartenBreadcrumb />,
            <VerpflegungsartBreadcrumb {...props}/>,
            <VerpflegungsartMahlzeitenBreadcrumb {...props} />,
        ]
    },
    {
        path: MAHLZEIT_PREIS_PATH,
        render: props => <VerticalSplit
            left={() => <PreiseNavigationView {...props}/>}
            right={() => <PreisView {...props}/>}
        />,
        createBreadcrumbs: props => [
            <MahlzeitenBreadcrumb />,
            <MahlzeitBreadcrumb {...props}/>,
            <PreiseBreadcrumb {...props}/>,
            <PreisBreadcrumb {...props} />,
        ]
    },
    {
        path: MAHLZEIT_PREIS_PATH,
        parentPath: MAHLZEIT_PREIS_PATH,
        exact: true,
        render: props => <PreisDetailsView {...props}/>,
        createBreadcrumbs: props => [
            <MahlzeitenBreadcrumb />,
            <MahlzeitBreadcrumb {...props}/>,
            <PreiseBreadcrumb {...props}/>,
            <PreisBreadcrumb {...props} />,
        ]
    },
    {
        path: MAHLZEIT_PREISPOSITIONEN_PATH,
        parentPath: MAHLZEIT_PREIS_PATH,
        exact: true,
        render: props => <PreispositionenView {...props} />,
        createBreadcrumbs: props => [
            <MahlzeitenBreadcrumb />,
            <MahlzeitBreadcrumb {...props}/>,
            <PreiseBreadcrumb {...props}/>,
            <PreisBreadcrumb {...props}/>,
            <PreispositionenBreadcrumb {...props}/>,
        ]
    },
    {
        path: MAHLZEIT_PREISPOSITION_PATH,
        render: props => <VerticalSplit
            left={() => <PreispositionenNavigationView {...props}/>}
            right={() => <PreispositionView {...props}/>}
        />,
        createBreadcrumbs: props => [
            <MahlzeitenBreadcrumb/>,
            <MahlzeitBreadcrumb {...props}/>,
            <PreiseBreadcrumb {...props}/>,
            <PreisBreadcrumb {...props}/>,
            <PreispositionenBreadcrumb {...props}/>,
            <PreispositionBreadcrumb {...props}/>,
        ]
    },
    {
        path: MAHLZEIT_PREISPOSITION_PATH,
        parentPath: MAHLZEIT_PREISPOSITION_PATH,
        exact: true,
        render: props => <PreispositionDetailsView {...props}/>,
        createBreadcrumbs: props => [
            <MahlzeitenBreadcrumb />,
            <MahlzeitBreadcrumb {...props}/>,
            <PreiseBreadcrumb {...props}/>,
            <PreisBreadcrumb {...props} />,
            <PreispositionenBreadcrumb {...props}/>,
            <PreispositionBreadcrumb {...props}/>,
        ]
    },
];
